

import {
  Component,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { MandatoDiPagamento } from "src/app/models/mandatoDiPagamento.model";

import { StiliService } from "src/app/services/stili.service";
import { UtilService } from "src/app/services/util.service";


@Component({
  templateUrl: "./dialog-complessivo-mdp.component.html",
  styleUrls: ["../bef.component.css"],
})
export class ComplessivoMDPComponent implements OnInit {
  protected _onDestroy              = new Subject<void>();
  
  protected isLoadingComplessivoMdp:Boolean = false;
  protected mdp:MandatoDiPagamento;
  

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public stiliService:StiliService,
    public config: DynamicDialogConfig,
    private messageService: MessageService,
    private utilService:UtilService,

  ) {
    this.mdp  = this.config.data.mdp;
  }

  ngOnInit(): void {
    
  }


  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.dialogRef.close({ success: true });
    }
  }
}
